var React = require('react');

function GraphArea (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 0C9 0 0 9 0 20C0 31 9 40 20 40C31 40 40 31 40 20C40 9 31 0 20 0ZM25.3 13L17.2 25.5L11.2 19.6L6.3 28.1C4.8 25.8 4 23 4 20C4 11.2 11.2 4 20 4C28.8 4 36 11.2 36 20C36 22.2 35.5 24.3 34.7 26.2L25.3 13Z"}));
}

GraphArea.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = GraphArea;

GraphArea.default = GraphArea;
